import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { TodayMenuService } from 'src/app/Services/todaymenu.service';
import * as moment from 'moment';
import { MenuItem } from 'src/app/Models/days-menu';
import { UserData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-todaysmenu',
  templateUrl: './todaysmenu.component.html',
  styleUrls: ['./todaysmenu.component.css'],
  providers: [TodayMenuService],
})
export class TodaysMenuComponent {
  userdata?: UserData;
  shpid: number | undefined;
  OBPortalSvcURL = '';

  MenuItems: MenuItem[] = [];
  MenuItemsTemp: MenuItem[] = [];
  Menudata: any;
  begdate: Date | string | undefined;
  enddate: Date | string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    private todayMenuService: TodayMenuService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.shpid = this.userdata?.shipid!;
    this.begdate = this.userdata?.pckgBeg;
    this.enddate = this.userdata?.pckgEnd;
    this.getTodaysMenu();
  }

  getTodaysMenu() {
    this.Menudata = this.todayMenuService
      .getTodaysMenu(this.shpid)
      .subscribe((menuData) => this.setTodaysMenu(menuData));
  }

  setTodaysMenu(resdata: any) {
    this.Menudata = resdata;

    if (this.Menudata.GetDaysMenu.Result.Status == 'A') {
      this.MenuItemsTemp = this.Menudata.GetDaysMenu.DaysMenuList;

      if (
        moment(this.MenuItemsTemp[0].ilcdate).isSame(
          moment(this.begdate).format('YYYY-MM-DD')
        )
      ) {
        //remove all the breakfast items if it's the first date of the cruise
        this.MenuItems = this.MenuItemsTemp.filter(
          (s: { mttName: string }) =>
            s.mttName.includes('Lunch') || s.mttName.includes('Dinner')
        );
      } else if (
        moment(this.MenuItemsTemp[0].ilcdate).isSame(
          moment(this.enddate).format('YYYY-MM-DD')
        )
      ) {
        //remove all the non breakfast items if it's the last day of the cruise

        this.MenuItems = this.MenuItemsTemp.filter(
          (s: { mttName: string }) =>
            s.mttName.includes('Breakfast') || s.mttName.includes('Eggs')
        );
      }
      //keep all the  items
      else {
        this.MenuItems = this.MenuItemsTemp;
      }
    }
  }
}
